import Vue from "vue";
import { gameStore } from "../store/game/store";
import _ from "lodash";
import { getInformantCardLetter } from "../functions";

export default Vue.extend({
  computed: {
    glasses() {
      return gameStore.state.tableGlasses;
    },
    cards(): string[] {
      const c = [];
      for (let index = 0; index < gameStore.state.tableCards; index++) {
        c.push(getInformantCardLetter(index));
      }
      return c;
    },
    myTurn() {
      return gameStore.state.currentPlayerId == gameStore.state.playerInfo.id;
    },
    clickable(): boolean {
      return this.myTurn && gameStore.state.playersGlasses[gameStore.state.playerInfo.id] > 0;
    }
  },
  methods: {
    promptConfirm(cardIndex: number) {
      if (!this.clickable) return;
      gameStore.commitToggleInformantDlg({
        show: true,
        cardIndex
      });
    }
  }
});